<template class="s">
	<div :id="baseId" :class="allClass">
		<div class="slide slide_info">
			<div class="infographic first">
				<img src="/images/home/v6/infographic.png" alt="img" class="setup-image" />
				<div class="expo">
					<h1>Fully Featured Integrations</h1>
					<p>Stan’s Integrations can help you to superpower your workflow by connecting your existing third-party tools.</p>
				</div>
			</div>

			<div class="infographic right">
				<img src="/images/home/v6/infographic-1.png" alt="img" class="setup-image" style="padding-bottom: 60px" />
				<div class="expo">
					<h1>One Tap Checkout</h1>
					<p>
						You shouldn’t have to go through hurdles just to sell your product. Stan brings the entire checkout process into your own
						hands.
					</p>
				</div>
			</div>

			<div class="infographic last">
				<img src="/images/home/v6/infographic-2.png" alt="img" class="setup-image" />
				<div class="expo">
					<h1>No Coding Required</h1>
					<p>
						Stan is super easy to use for beginners, and you really don’t need any coding experience to get started. We think even a
						caveman could do it.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { computed, defineProps } from 'vue'
	const props = defineProps({
		id: {
			type: [String, Number],
		},
		class: { type: [String] },
		activeComponent: { type: Boolean },
	})
	const allClass = computed(() => `setup-steps-panel ${props.class}`)
	const baseId = computed(() => `${props.id}`)
	const addonId = computed(() => `${props.id}-add-on`)
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/helpers-v6.scss';

	#setup {
		background: white;
	}
	.first {
		padding-top: 0px;
		@media screen and (max-width: 1200px) {
			align-items: flex-start !important;
		}
	}
	.last {
		@media screen and (max-width: 1200px) {
			align-items: flex-start !important;
		}
	}

	.slide_info {
		image-rendering: -webkit-optimize-contrast;
		padding-bottom: 50px;
		width: 100vw;
		.infographic {
			width: 100vw;
			display: flex;
			flex-direction: row;
			align-items: center !important;
			.expo {
				width: 600px;
				max-width: 100%;
				padding: 0;
				padding-inline: 100px;

				h1 {
					font-size: 40px;
					font-weight: 800;
					margin: 0;
					margin-bottom: 24px;
				}

				p {
					font-family: Plus Jakarta Sans, Inter, sans-serif;
					letter-spacing: -0.1px;
					font-size: 18px;
					font-weight: 500;
					line-height: 140%;
					margin: 0;

				}
			}

			&.right {
				flex-direction: row-reverse;
			}

			.setup-image {
				height: auto;
				width: 720px;
				max-width: 50%;

				@media screen and (max-width: 800px) {

					height: auto;
					max-width: 720px;
					width: 100%;
				}
			}
		}
	}
	@media screen and (max-width: 900px) {
		.slide_info {
			display: flex;
			flex-direction: column;
			gap: 80px;
			.infographic {
				width: 100vw;
				height: fit-content;
				display: flex;
				flex-direction: column;
				gap: 0px;
				img {
					width: 100vw;
					height: auto;
				}

				.expo {
					width: 80vw;
					padding: 8vw;
					padding-inline: 60px;
					h1 {
						font-size: 36px;
						font-weight: 800;
						margin-bottom: 20px;
					}

					p {
						font-size: 24px;
						line-height: 150%;
					}
				}

				&.right {
					flex-direction: column;
					align-items: flex-start;
					text-align: left;
				}
			}
		}

		.addon {
			height: 400px !important;
			padding: 0 !important;
			margin-top: -200px !important;
			padding-bottom: 150px !important;
		}
	}

	@media screen and (max-width: 767px) {
		.slide_info {
			.infographic {
				.expo {
					width: 80vw;
					padding-inline: 20px;
					padding-block: 0px;
					padding: 8px 32px;
					h1 {
						font-size: 28px;
						font-weight: 800;
						margin-bottom: 12px;
					}

					p {
						font-size: 16px;
						line-height: 150%;
					}
				}
			}
		}
	}

	.landing-page-component {
		&.setup-steps-panel,
		&.setup-steps-panel-try-stan-block {
			box-sizing: unset;
			padding-block: 50px;
			@media (max-width: $primary-mobile-breakpoint-px) {
				box-sizing: unset;
				padding-top: -300px;
			}
		}
	}

	.setup-steps-panel {
		&-try-stan-block {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin: auto;
			--max-size: 100;
			--min-size: 63;
			padding-top: min(calc(1px * var(--max-size)), var(--responsive));
			padding-left: max(15px, calc(var(--responsive) - 75px));
			padding-bottom: 77px;

			h3,
			button.panel-button {
				font-family: Plus Jakarta Sans, sans-serif;
				font-style: normal;
				font-weight: 800;
				padding-left: 19px;
			}

			h3 {
				--max-size: 50;
				--min-size: 24;
				font-size: 36px;
				line-height: 105%;
				text-align: center;
				letter-spacing: 0.009em;
				margin-bottom: 60px;
				@media (max-width: var(--primary-mobile-breakpoint-px)) {
					& {
						font-size: 24px;
						margin-bottom: 30px;
					}
				}
			}

			.panel-button {
				width: 80%;
				max-width: 320px;

				border: none;
				background: #131f60;
				box-shadow: 0 40px 40px rgba(0, 0, 0, 0.1);
				border-radius: 50px;
				transition: 0.2s ease;
				height: fit-content;

				padding: 28px 0 32px 0;

				&:hover {
					background: #090e2a;
				}
				&-content {
					padding: 0;
					&--text {
						color: #ffffff;
						font-size: 24px;
						line-height: 100%;
						font-weight: 700;
						text-align: center;
						transform: translateX(-10px);
					}
				}
			}

			@media (max-width: $primary-mobile-breakpoint-px) {
				margin: unset;
				padding-top: 44px;
				padding-left: 0;

				transform: translateY(120px);

				h3 {
					font-size: 24px;
					margin-bottom: 25px;
					padding-left: 0;
					margin-top: 100px;
				}
				.panel-button {
					margin-top: 32px;
					padding: 24px 0 28px 0;
					&-content {
						&--text {
							font-size: 20px;
						}
					}
				}
			}
		}
	}

	.align-content-center {
		align-content: center;
	}
</style>
